import {
    GET_QUOTES,
    GET_QUOTES_SUCCESS,
    GET_QUOTES_FAIL,
    GET_QUOTE_DETAIL,
    GET_QUOTE_DETAIL_SUCCESS,
    GET_QUOTE_DETAIL_FAIL,
    ADD_NEW_QUOTE,
    ADD_NEW_QUOTE_SUCCESS,
    ADD_NEW_QUOTE_FAIL,
    UPDATE_QUOTE,
    UPDATE_QUOTE_SUCCESS,
    UPDATE_QUOTE_FAIL,
    DELETE_QUOTE,
    DELETE_QUOTE_SUCCESS,
    DELETE_QUOTE_FAIL,
    CONVERT_QUOTE_TO_INVOICE,
    CONVERT_QUOTE_TO_INVOICE_SUCCESS,
    CONVERT_QUOTE_TO_INVOICE_FAIL,
} from "./actionTypes"

export const getQuotes = (params) => ({
    type: GET_QUOTES,
    payload: params,
})

export const getQuotesSuccess = (quotes) => ({
    type: GET_QUOTES_SUCCESS,
    payload: quotes,
})

export const getQuotesFail = (error) => ({
    type: GET_QUOTES_FAIL,
    payload: error,
})

export const getQuoteDetail = (id) => ({
    type: GET_QUOTE_DETAIL,
    payload: id,
})

export const getQuoteDetailSuccess = (quote) => ({
    type: GET_QUOTE_DETAIL_SUCCESS,
    payload: quote,
})

export const getQuoteDetailFail = (error) => ({
    type: GET_QUOTE_DETAIL_FAIL,
    payload: error,
})

export const addNewQuote = (quote, history) => ({
    type: ADD_NEW_QUOTE,
    payload: { quote, history },
})

export const addNewQuoteSuccess = (quote) => ({
    type: ADD_NEW_QUOTE_SUCCESS,
    payload: quote,
})

export const addNewQuoteFail = (error) => ({
    type: ADD_NEW_QUOTE_FAIL,
    payload: error,
})

export const updateQuote = (quote, history) => ({
    type: UPDATE_QUOTE,
    payload: { quote, history },
})

export const updateQuoteSuccess = (quote) => ({
    type: UPDATE_QUOTE_SUCCESS,
    payload: quote,
})

export const updateQuoteFail = (error) => ({
    type: UPDATE_QUOTE_FAIL,
    payload: error,
})

export const deleteQuote = (id) => ({
    type: DELETE_QUOTE,
    payload: id,
})

export const deleteQuoteSuccess = (id) => ({
    type: DELETE_QUOTE_SUCCESS,
    payload: id,
})

export const deleteQuoteFail = (error) => ({
    type: DELETE_QUOTE_FAIL,
    payload: error,
})

export const convertQuoteToInvoice = (id, history) => ({
    type: CONVERT_QUOTE_TO_INVOICE,
    payload: { id, history },
})

export const convertQuoteToInvoiceSuccess = (invoice) => ({
    type: CONVERT_QUOTE_TO_INVOICE_SUCCESS,
    payload: invoice,
})

export const convertQuoteToInvoiceFail = (error) => ({
    type: CONVERT_QUOTE_TO_INVOICE_FAIL,
    payload: error,
})
